import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'

export default {
    name: 'course_create',
    props: {
        admin : Boolean
    },

    data : function(){

        return {
            loading : false,
            value : '',
            locale : 'ru',
            ageCluster : '0-3'
        }

    },

    created : () => {

    },

    mounted(){
        setTimeout(() => {  
            this.$refs['forminput']?.focus()
        }, 500)
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        locales : function(){
            return f.deep(this.core, 'appInfo.snippity.settings.locales') || []
        },

        ageClusters: function(){
            return f.deep(this.core, 'appInfo.snippity.settings.ageClusters') || []
        },

        fields : function(){
            return [
                {
                    id: 'locale',
                    input: 'select',
                    text: 'snippity.selectlocaleLabel',
                    values : _.map(this.locales, (locale) => {
                        return {
                            value : locale,
                            text : "locales." + locale
                        }
                    })
                },

                {
                    id: 'ageCluster',
                    input: 'select',
                    text: 'snippity.selectageClusterLabel',
                    values : _.map(this.ageClusters, (ageCluster) => {
                        return {
                            value : ageCluster.join('-'),
                            text : ageCluster.join('-')
                        }
                    })
                },
            ]
        }
        
    }),

    methods : {
        create : function(){

            this.core.promwrapper(this.admin ? this.core.api.lessons.admin.create(this.locale, this.value, this.ageCluster) : this.core.api.lessons.create(this.value), { hideicons : true} ).then(() => {

                this.$dialog.alert(
                    this.$t('snippity.lessonsSuccess'), {
                    okText: this.$t('app.okay')
                }).catch(e => {

                })

                this.$emit('close')

            }).catch(e => {

                var text = ''

                if(e.validationError){
                    text = e.validationError
                }
                else{
                    text = this.$t('snippity.lessonsError.' + e) == ('snippity.lessonsError.' + e) ? e : this.$t('snippity.lessonsError.' + e)
                }

                this.$dialog.alert(
                    text, {
                    okText: this.$t('app.okay')
                }).catch(e => {

                })
            })
        },

        input : function(v){
            this.value = v
        },

        inputform : function(v){
            this.locale = v.locale
            this.ageCluster = v.ageCluster
        }
    },
}